import { EntityConfig } from './entity-registry';
import { GenericTableColumn, GenericTableAction } from '../../../../../models/GenericCRUD/GenericTable';
import { GenericFormField } from '../../../../../models/GenericCRUD/GenericForm';
import { Filter } from '../../../../../models/GenericCRUD/Filter';

// Configuración extraída de BanksHomeComponent
const tableColumns: GenericTableColumn[] = [
  { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
  { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
  { name: 'Número de Cuenta', active: true, type: 'text', key: 'account_number', sort: false },
  { name: 'Titular', active: true, type: 'text', key: 'account_holder', sort: false },
  { name: 'Estado', active: true, type: 'boolean', key: 'active', sort: true }
];

const formFields: GenericFormField[] = [
  { name: 'name', type: 'text', label: 'Nombre del Banco', validations: 'required', colspan: 2 },
  { name: 'code', type: 'text', label: 'Código', validations: '', colspan: 1 },
  { name: 'account_number', type: 'text', label: 'Número de Cuenta', validations: 'required', colspan: 1 },
  { name: 'account_holder', type: 'text', label: 'Titular', validations: '', colspan: 2 },
  { name: 'initial_balance', type: 'number', label: 'Saldo Inicial', validations: 'required', colspan: 1 },
  { name: 'active', type: 'boolean-switch', label: 'Activo', validations: '', colspan: 1 }
];

const formFieldsEdit: GenericFormField[] = [
  { name: 'name', type: 'text', label: 'Nombre del Banco', validations: 'required', colspan: 2 },
  { name: 'code', type: 'text', label: 'Código', validations: '', colspan: 1 },
  { name: 'account_number', type: 'text', label: 'Número de Cuenta', validations: 'required', colspan: 1 },
  { name: 'account_holder', type: 'text', label: 'Titular', validations: '', colspan: 2 },
  { name: 'active', type: 'boolean-switch', label: 'Activo', validations: '', colspan: 2 }
];

const tableActions: GenericTableAction[] = [
  {
    name: 'Editar',
    key: 'edit',
    form: {
      method: 'PUT',
      successTitle: 'Edición correcta',
      errorTitle: 'Error en la edición',
      fields: formFieldsEdit,
      name: 'banco',
      createButtonTitle: '',
      cols: 2,
      createApiSlug: '',
      originalUpdateApiSlug: '/bank/update/{{id}}',
      updateApiSlug: '',
      originalFormTitle: 'Editar {{name}}',
      formTitle: 'Editar banco',
      formButtonTitle: 'Editar',
      width: '3xl'
    },
    completeForm: true,
    replaceAllRowOnResponse: true,
    icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" /><path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" /><path d="M16 5l3 3" /></svg>',
    confirmation: false
  },
  {
    name: 'Eliminar',
    key: 'delete',
    method: 'DELETE',
    icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
    confirmation: true,
    questionText: '¿Desea eliminar este banco?',
    deleteRowOnResponse: true,
    actionSlug: '/bank/delete/{{id}}'
  }
];

const filters: Filter[] = [
  { type: 'search', key: 'name|account_number', operator: 'like', placeholder: 'Nombre o número de cuenta' }
];

/**
 * Configuración completa de la entidad Bancos
 */
export const banksConfig: EntityConfig = {
  id: 'banks',
  name: 'Bancos',
  icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/></svg>',

  tableColumns,
  formFields,
  formFieldsEdit,
  tableActions,
  filters,

  form: {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: formFields,
    name: 'banco',
    createButtonTitle: 'Nuevo banco',
    cols: 2,
    createApiSlug: '/bank/store',
    formTitle: 'Crear banco',
    formButtonTitle: 'Crear banco',
    width: '3xl'
  },

  table: {
    columns: tableColumns,
    items: [],
    type: 'generic',
    loadItemsSlug: '/bank/index',
    paginate: true,
    name: 'bancos',
    actions: tableActions,
    details: true,
    detailsSlug: '/dashboard/administracion/banks/{{id}}'
  },

  useModalForm: true
};
